<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/njueiP/tc-custom/9798889101178.jpg?1716663068508" alt="This image is the cover for the book Danielle"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Danielle
      </h1>
      <p class="bookDescription body article font2">
        <p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:16px;font-family:"Times New Roman",serif;'>In <em>Danielle,</em> the author invites readers into an intimate journey through the life of her seven-year-old daughter, who courageously battled cancer. Far from being just a heartbreaking narrative, this true story illuminates the transformative power of suffering when united with faith. Danielle, with her extraordinary spiritual maturity, finds strength and inspiration from her favorite saint, St. Therese of Lisieux, while navigating the complexities of illness.</span></p><p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:16px;font-family:"Times New Roman",serif;'>This book transcends the usual narratives of tragedy and loss by offering a message of hope and grace. Through sharing the family’s experience – Danielle’s remarkable perspective on life, her deep relationship with God, and her steadfast resilience – the author aims to reveal the beauty that can be found even in immense suffering. <em>Danielle</em> serves as a poignant reminder that life’s hardships and joys are both cradled in the hands of God, and it challenges us to embrace them as such.</span></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Myra J. Martinez
      </h2>
      
      <p class="authorDescription body article"><p style='margin:0mm;font-size:15px;font-family:"Arial",sans-serif;text-align:justify;'><span style='font-family:"Times New Roman",serif;color:black;background:white;'>As a mother of nine children and many grandchildren, Myra J. Martinez, has much experience in the challenges of motherhood. She has also endured much suffering with her oldest child&rsquo;s childhood cancer while raising a large family. </span></p><p style='margin:0mm;font-size:15px;font-family:"Arial",sans-serif;text-align:justify;'><br></p><p style='margin:0mm;font-size:15px;font-family:"Arial",sans-serif;text-align:justify;'><span style='font-family:"Times New Roman",serif;color:black;background:white;'>She enjoys cooking, spending time with and entertaining her large family. She has also taken her experience to the Gospel of Life Disciples, where she spends time loving, comforting, ministering, and praying with those who are dying. She lives in Oklahoma, married to her grade school sweetheart, Philip, and their growing family.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?33b149c2